import { makeAutoObservable } from "mobx";
import ContractService from "../api/services/ContractService";
import { IContractTaxes } from "api/interfaces";
import { BetweenValuesException } from "../api/exceptions/InvalidValueException";
import { ContractStore, MessageStore } from "./";
import { lang } from "../i18nLang";

const validationTaxe = (value) => {
  if (!value || (value >= 0 && value <= 100)) return;

  const error = new BetweenValuesException(value, 0, 100);
  return {
    valid: false,
    text: error.customMessage,
  };
};

class Store {
  private _fields?: Partial<IContractTaxes>;
  public readonly validations = {
    inss: validationTaxe,
    iss: validationTaxe,
    pis: validationTaxe,
    cofins: validationTaxe,
    csll: validationTaxe,
  };

  constructor() {
    makeAutoObservable(this);
  }

  get fields() {
    return this._fields;
  }

  reloadFields() {
    this._fields = undefined;
    const contract = ContractStore.getCurrentContract();

    if (contract) {
      this._fields = contract.taxes;
    }
  }

  setFields(field, value) {
    if (!field) {
      return;
    }

    let newFields = { ...this._fields };
    newFields[field] = value;

    this._fields = { ...newFields };
  }

  updateTaxes() {
    const fields = this._fields;
    const taxes = {
      inss: fields?.inss || 0,
      iss: fields?.iss || 0,
      pis: fields?.pis || 0,
      cofins: fields?.cofins || 0,
      csll: fields?.csll || 0,
    };

    return ContractService.updateTaxes(
      ContractStore.getCurrentContract()?.uid || "",
      taxes
    )
      .then(() => {
        MessageStore.success(lang("taxes.success"));
        return true;
      })
      .catch((error) => {
        console.error();
        MessageStore.error(error.message);
        return false;
      });
  }
}

const TaxesStore = new Store();
export default TaxesStore;
